import { type ApiRequest } from '@/api/tenantClient';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import { type UserSession, useUserSession } from '@/registration/hook/useUserSession';
import { useLocale } from '@/registration/component/Locale/LocaleProvider';

export function useTenantApi() {
  const { tenant, isLoading: isTenantLoading } = useTenantRoute();
  const { userSession } = useUserSession();

  /**
   * @todo This line needs to be reviewed in details.
   *      The locale provider isn't very up in the render tree meaning that there could be components which call this useTenantApi hook but out of the local provider.
   *      This is due to the bad design of the routes.
   *      Might have to wrap the locale provider in every single routes in pages.tsx...
   */
  const {currentLocale} = useLocale();

  const createTenantApiRequest = (): ApiRequest => {
    return {
      method: 'POST',
      endpoint: {
        host: tenant?.apiEndpoint,
        path: ''
      },
      headers: {
        uid: userSession?.email ?? '',
        client: userSession?.client ?? '',
        'access-token': userSession?.authToken ?? '',
        'locale-id': `${currentLocale?.id ?? ''}`, // This should allow us to pass the locale id in the header of every API call.
      },
    };
  };

  return {
    createTenantApiRequest,
    isLoading: isTenantLoading
  };
}
